import type {ProLayoutProps} from '@ant-design/pro-components';

/**
 * @name ProLayout 默认设置
 */
const Settings: ProLayoutProps & {
    pwa?: boolean;
    logo?: string;
    title?: string;
  } = {
    "navTheme": "light",
    "colorPrimary": "#165DFF",
    "layout": "mix",
    "contentWidth": "Fluid",
    "fixedHeader": true,
    "fixSiderbar": true,
    "pwa": false,
    "logo": "/squirrel-logo.svg",
    "title": "松鼠",
    "token": {},
    "splitMenus": true,
    "siderMenuType": "sub",
    "siderWidth": 155,
    "menu": {
      "locale": false,
      "defaultOpenAll": true,
      "autoClose": false
    },
    "footerRender": false
  };

export default Settings;
